export default __webpack_public_path__ + "static/media/getInTouch.d8d3dc73.png";